// src/core/utils/generateId.tsx
import { customAlphabet } from "nanoid/non-secure";
var generateId = customAlphabet(
  "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz",
  7
);
export {
  generateId
};
//# sourceMappingURL=generateId.js.map